let currentToken: string | null = null;
let refreshHRTokenFn: (() => Promise<any>) | null = null;

export const setAxiosToken = (token: string | null) => {
  currentToken = token;
};

export const getAxiosToken = () => currentToken;

export const registerHRTokenRefresher = (fn: () => Promise<any>) => {
  refreshHRTokenFn = fn;
};

export const refreshHRToken = async () => {
  if (!refreshHRTokenFn) {
    throw new Error('HR token refresher not registered');
  }

  return refreshHRTokenFn();
};
